import { render } from "./Services4Section.vue?vue&type=template&id=524d1c68&scoped=true"
import script from "./Services4Section.vue?vue&type=script&lang=js"
export * from "./Services4Section.vue?vue&type=script&lang=js"

import "./Services4Section.vue?vue&type=style&index=0&id=524d1c68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524d1c68"]])

export default __exports__